import React, { useEffect, useMemo, useRef, useState } from "react";
import { connectToolbarDesktop } from "./ToolbarDesktop.connect";
import TimeSettingsDesktop from "./TimeSettingsDesktop/TimeSettingsDesktop";
import LeftSideMenu from "../LeftSideMenu/LeftSideMenu";
import RightSideMenu from "../RightSideMenu/RightSideMenu";
import { DEFAULT_THEME, IS_B2C, IS_SIGNUP_SHOW } from "../../config/api.config";
import SVG_DepositIcon from "../../assets/images/svgs/Deposit.svg?react";
import SVG_WithdrawIcon from "../../assets/images/svgs/Withdraw.svg?react";
import SVG_SearchIcon from "../../assets/images/svgs/search_light.svg?react";
import SVG_SettingIcon from "../../assets/images/svgs/settings_white.svg?react";
import SVG_BacktIcon from "../../assets/images/svgs/chevronleft.svg?react";
import SVG_SpadeIcon from "../../assets/images/svgs/spade.svg?react";
import SVG_CardDeckIcon from "../../assets/images/svgs/cards-deck.svg?react";
import SVG_RocketIcon from "../../assets/images/svgs/rocket.svg?react";
import SVG_DiceIcon from "../../assets/images/svgs/dice.svg?react";
import SVG_FishIcon from "../../assets/images/svgs/fish.svg?react";
import SVG_LoginIcon from "../../assets/images/svgs/login.svg?react";
import SVG_AddUserIcon from "../../assets/images/svgs/addUser.svg?react";
import SVG_UserIcon from "../../assets/images/svgs/user.svg?react";
import SVG_CloseIcon from "../../assets/images/svgs/close-white.svg?react";
import SVG_MenuIcon from "../../assets/images/svgs/menu.svg?react";
import SVG_NotiCloseIcon from "../../assets/images/svgs/notificationClose.svg?react";
import SVG_BellIcon from "../../assets/images/svgs/bell.svg?react";
import SVG_SportsBook from "../../assets/images/svgs/sportsBook.svg?react";
import SVG_CricketIcon from "../../assets/images/svgs/cricket.svg?react";
import SVG_FootballIcon from "../../assets/images/svgs/football.svg?react";
import SVG_GreyhoundIcon from "../../assets/images/svgs/greyhound.svg";
import SVG_HorseIcon from "../../assets/images/svgs/horse.svg?react";
import SVG_TennisIcon from "../../assets/images/svgs/tennis.svg?react";
import SVG_HomeIcon from "../../assets/images/svgs/home.svg?react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { pagesInfoMapper } from "../../helpers/pagesinfoMapper.helper";
import { getCurrencyFormat } from "../../helpers/getCurrencyFormat.helper";
import SearchDesktop from "../SearchDesktop/SearchDesktop";
import httpAuth from "../../services/httpAuth";
import moment from "moment";
import { USER_DATA } from "../../config/app.config";
import { toastr } from "react-redux-toastr";
import useTheme from "../../hooks/useTheme";

const ToolbarDesktop = ({
  balance,
  messages,
  notifications,
  user,
  contentScrolled = false,
  setStyle = () => null,
  actions,
  search = false,
  noSearch = true,
  menu,
  auth,
  B2C,
  animatedText,
  searchValue,
  logo,
  language,
  isNotificationOpen,
  hideNews,
  setHideNews,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const storedTime = localStorage.getItem("lastVisitTime");

  const [openSearch, setOpenSearch] = useState(false);
  const [leftSideMenuOpen, setLeftSideMenuOpen] = useState(false);
  const [rightSideMenuOpen, setRightSideMenuOpen] = useState(false);
  const [pageInfo, setPageInfo] = useState(null);
  const [lastLoggedIn, setLastLoggedIn] = useState("");

  let userDetail = localStorage?.getItem(USER_DATA);
  let userData = userDetail && JSON.parse(userDetail);

  useEffect(() => {
    if (storedTime) {
      setLastLoggedIn(storedTime);
    } else {
      const currentTime = new Date()
        .toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        })
        .replace(",", "");

      localStorage.setItem("lastVisitTime", currentTime);
      setLastLoggedIn(currentTime);
    }
  }, [storedTime]);

  useEffect(() => {
    const segmant = location.pathname.split("/");
    const required = pagesInfoMapper[segmant[1]];
    if (!!required) {
      if (
        segmant[1] == "sports-page" ||
        segmant[1] == "competition-detail-page"
      ) {
        setPageInfo({
          ...required,
          headerName: decodeURIComponent(segmant[2]),
        });
      } else if (segmant[1] == "casino-lobby") {
        setPageInfo({
          ...required,
          headerName: setCasinoLobbyHeaderName(segmant),
        });
      } else {
        setPageInfo(required);
      }
    } else {
      setPageInfo(pagesInfoMapper["default-page"]);
    }
  }, [location]);

  const setCasinoLobbyHeaderName = (segmant) => {
    let correctSegment = segmant.map((item) =>
      decodeURIComponent(item).replace(/-/g, " "),
    );
    if (segmant[2]?.toLowerCase() == "provider") {
      return correctSegment.slice(2, -1).join("/");
    }
    return correctSegment.slice(2).join("/");
  };

  const refScroll = useRef(null);

  const hableSearchChange = (value) => {
    actions.setSearchValues(value);
  };

  useEffect(() => {
    actions.setSearchValue(searchValue);
  }, [actions, searchValue]);

  useEffect(() => {
    if (contentScrolled) {
      setStyle({
        transform: `translate3d(0px, -${refScroll.current.clientHeight}px, 0px)`,
        height: "50px",
      });
    } else {
      setStyle({
        transform: "none",
      });
    }
  }, [contentScrolled, setStyle]);

  const isSportAvailable = (id) => {
    return menu.some((sport) => sport.sport_id === id);
  };

  const getMenu = (data) => {
    actions
      .requestRacingPageData(data)
      .catch((e) => console.log("menu error = ", e));
  };

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        actions.setIsNotificationOpen(false); // Close dropdown
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [dropdownRef]);

  const [newsData, setNewsData] = useState([]);

  const fetNews = async () => {
    await actions.getNews().then((res) => {
      if (res.data.status) {
        setNewsData(res?.data?.data);
        if (res?.data?.data?.length === 0) {
          setHideNews(false);
        }
      } else {
        setNewsData([]);
      }
    });
  };
  useEffect(() => {
    if (auth) {
      fetNews();
    }
  }, [auth]);

  const LanguageChange = () => {
    return (
      <>
        <button
          className="relative overflow-hidden md:hidden  flex items-center md:ml-2 text-text_color_primary2 justify-center text-xs py-1 md:py-2 px-1 md:px-2"
          type="button"
          style={{ color: "#fff" }}
          onClick={() => {
            actions.setIsLangauage(true);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="w-5 h-5 mr-0.5"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
            <path d="M3.6 9h16.8"></path>
            <path d="M3.6 15h16.8"></path>
            <path d="M11.5 3a17 17 0 0 0 0 18"></path>
            <path d="M12.5 3a17 17 0 0 1 0 18"></path>
          </svg>
        </button>
        <button
          className="relative overflow-hidden hidden md:flex items-center md:ml-2 text-text_color_primary2 justify-center text-xs py-1 md:py-2 px-1 md:px-2 rounded-full bg-bg_color_secondary border border-border_color_primary"
          type="button"
          style={{ color: "#fff" }}
          onClick={() => {
            actions.setIsLangauage(true);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="w-4 h-4 mr-0.5"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
            <path d="M3.6 9h16.8"></path>
            <path d="M3.6 15h16.8"></path>
            <path d="M11.5 3a17 17 0 0 0 0 18"></path>
            <path d="M12.5 3a17 17 0 0 1 0 18"></path>
          </svg>
          {language?.toUpperCase()}
          <svg
            fill="currentColor"
            width="16"
            height="16"
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 330 330"
            className="w-3 h-3 ml-2"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <path
                id="XMLID_225_"
                d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393 c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393 s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"
              ></path>
            </g>
          </svg>
        </button>
      </>
    );
  };

  const memoizedNotification = useMemo(() => {
    return (
      <div className=" w-max h-max relative font-lato" ref={dropdownRef}>
        <div
          className="bg-none border-none shadow-none px-1 mr-2 cursor-pointer transition-all ease-in-out duration-200 active:scale-105"
          style={{ position: "relative" }}
          onClick={() => actions.setIsNotificationOpen(!isNotificationOpen)}
        >
          <SVG_BellIcon />
          <div
            className="absolute top-[-8px] right-[-1px] text-text_color_loginButtonTextColor bg-bg_color_LoginBtnBgColor font-lato font-bold text-[12px] rounded-[50%] w-[18px] h-[18px] flex items-center justify-center "
            style={{
              color: "#fff",
            }}
          >
            <span> {newsData?.length ?? 0}</span>
          </div>
        </div>
        {isNotificationOpen && (
          <div
            className=" absolute bg-bg_Quaternary popUpOpenAnimation origin-top-right right-[10%] md:top-[125%] px-1 md:px-1.5 md:py-1.5 sm:px-[3px] py-1  flex flex-col bg-bg_color_primary rounded-[5px] shadow-notificationBoxShadow text-text_color_primary1  overflow-y-auto
             max-h-[300px] 
             
              w-[180px]               
              md:w-[200px]
              sm:w-[200px]
              lg:w-[300px]
              "
            style={{
              zIndex: 1000,
              top: "100%",
              // backgroundColor: "#fff",
            }}
          >
            <div className=" w-full py-1 flex items-center  justify-between ">
              <span className=" text-text_brand_secondary text-sm md:text-base font-bold">
                Notifications
              </span>
              <span>
                <div
                  className="transition-all active:scale-[103%] ease-in-out duration-200 hover:scale-105 }"
                  onClick={() =>
                    actions.setIsNotificationOpen(!isNotificationOpen)
                  }
                >
                  <SVG_NotiCloseIcon />
                </div>
              </span>
            </div>

            {newsData?.length > 0 ? (
              newsData?.map((item, idx) => (
                <div
                  key={idx}
                  className="text-sm w-full text-text_Ternary  md:text-base font-lato transition-all ease-in-out duration-200 md:hover:scale-y-[102%] md:hover:scale-x-[101.5%] md:hover:bg-bg_color_quaternary px-1 rounded-sm"
                >
                  {item?.heading}
                </div>
              ))
            ) : (
              <div className=" font-lato items-center py-2 font-medium  justify-center w-full flex flex-col">
                <span className=" animate-shake">🔔</span>
                <span>All caught up! No notifications at the moment.</span>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }, [isNotificationOpen, newsData]);

  const [theme, setTheme] = useTheme();

  const memoizedRightMenu = useMemo(() => {
    return (
      <>
        {auth ? (
          <div className=" flex justify-between items-center gap-x-1 h-max lg:hidden">
            <LanguageChange />

            {/* {memoizedNotification} */}
            {/* {IS_B2C && (
              <button
                type="button"
                className=" leading-normal  transition duration-150 ease-in-out overflow-hidden relative active:scale-95 hidden xxs:flex items-center h-fit justify-center bg-bg_Quaternary rounded-full px-3 py-1 sm:px-4 sm:py-1.5 text-text_Primary   text-sm   text-center  cursor-pointer"
                onClick={() => {
                  navigate("/deposit");
                }}
              >
                <span className="  font-semibold flex flex-row font-lato md:font-normal sm:text-base xs:text-sm">
                  <span>Deposit</span>
                </span>
                <span className="shimmer"></span>
              </button>
            )} */}
            {!userData?.is_demo && IS_B2C && (
              <button
                type="button"
                className=" leading-normal  transition duration-150 ease-in-out overflow-hidden relative active:scale-95 hidden xxs:flex items-center h-fit justify-center  rounded-full px-3 py-1 sm:px-4 sm:py-1.5 text-text_Primary   text-sm   text-center  cursor-pointer"
                onClick={() => {
                  navigate("/deposit");
                }}
              >
                {/* <span className="  font-semibold flex flex-row font-lato md:font-normal sm:text-base xs:text-sm">
                  <span>Deposit</span>
                </span> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="19"
                  viewBox="0 0 21 19"
                  fill="none"
                >
                  <path
                    d="M3.62143 4.52979C3.52275 4.52988 3.42507 4.54945 3.33397 4.58737C3.24287 4.62528 3.16014 4.68079 3.09054 4.75074C3.02094 4.82068 2.96584 4.90368 2.92837 4.99496C2.8909 5.08624 2.87181 5.18402 2.8722 5.28269C2.8724 5.48134 2.95139 5.67179 3.09185 5.81225C3.23232 5.95271 3.42278 6.03171 3.62143 6.03191H16.6423C17.4549 6.03191 18.0115 6.5801 18.0115 7.19078V8.50099C18.0111 8.59998 18.0303 8.69805 18.068 8.78958C18.1057 8.8811 18.1612 8.96425 18.2312 9.03424C18.3012 9.10424 18.3843 9.15969 18.4758 9.19739C18.5674 9.23508 18.6654 9.25429 18.7644 9.2539C18.8631 9.2538 18.9608 9.23424 19.0519 9.19632C19.143 9.1584 19.2257 9.10288 19.2953 9.03293C19.3649 8.96299 19.42 8.87999 19.4575 8.78871C19.4949 8.69743 19.514 8.59966 19.5136 8.50099V7.19078C19.5136 5.6859 18.1796 4.52979 16.6423 4.52979H3.62143Z"
                    fill="#fff"
                  ></path>
                  <path
                    d="M16.6606 7.75177C15.5639 7.75177 14.6603 8.65906 14.6603 9.75583V11.2579C14.6603 12.3547 15.5639 13.262 16.6606 13.262H18.7459C19.8427 13.262 20.75 12.3547 20.75 11.2579V9.75583C20.75 8.65906 19.8427 7.75177 18.7459 7.75177H16.6606ZM16.6606 9.25389H18.7459C19.032 9.25389 19.2478 9.46966 19.2478 9.75583V11.2579C19.2478 11.5441 19.032 11.7599 18.7459 11.7599H16.6606C16.3745 11.7599 16.1587 11.5441 16.1587 11.2579V9.75583C16.1587 9.46966 16.3745 9.25389 16.6606 9.25389Z"
                    fill="#fff"
                  ></path>
                  <path
                    d="M10.2315 13.0663C10.0329 13.0665 9.84242 13.1455 9.70195 13.286C9.56149 13.4265 9.4825 13.6169 9.4823 13.8156V17.7499C9.4825 17.9485 9.56149 18.139 9.70195 18.2794C9.84242 18.4199 10.0329 18.4989 10.2315 18.4991C10.4302 18.4989 10.6206 18.4199 10.7611 18.2794C10.9015 18.139 10.9805 17.9485 10.9807 17.7499V13.8156C10.9805 13.6169 10.9015 13.4265 10.7611 13.286C10.6206 13.1455 10.4302 13.0665 10.2315 13.0663Z"
                    fill="#fff"
                  ></path>
                  <path
                    d="M10.2315 13.0663C10.1327 13.0664 10.0348 13.086 9.94364 13.124C9.85243 13.162 9.76964 13.2177 9.70001 13.2878L7.72179 15.2771C7.58156 15.4177 7.50281 15.6081 7.50281 15.8067C7.50281 16.0053 7.58156 16.1957 7.72179 16.3363C7.79147 16.4063 7.8743 16.4619 7.9655 16.4997C8.05671 16.5376 8.15449 16.5571 8.25325 16.5571C8.35201 16.5571 8.44981 16.5376 8.54101 16.4997C8.63221 16.4619 8.71503 16.4063 8.78471 16.3363L10.7629 14.347C10.8327 14.2771 10.8879 14.1941 10.9255 14.1027C10.9631 14.0114 10.9822 13.9135 10.9819 13.8148C10.9815 13.716 10.9617 13.6183 10.9234 13.5272C10.8852 13.4361 10.8294 13.3535 10.7592 13.2841C10.6188 13.1448 10.4292 13.0665 10.2315 13.0663Z"
                    fill="#fff"
                  ></path>
                  <path
                    d="M10.2353 13.0664C10.1367 13.0659 10.0391 13.085 9.94786 13.1223C9.85667 13.1597 9.77374 13.2147 9.70381 13.2841C9.63357 13.3535 9.57774 13.4361 9.53952 13.5272C9.5013 13.6183 9.48143 13.716 9.48108 13.8148C9.48073 13.9135 9.4999 14.0114 9.53747 14.1027C9.57504 14.1941 9.63028 14.2771 9.70002 14.347L11.6783 16.3363C11.7479 16.4063 11.8308 16.4619 11.922 16.4998C12.0132 16.5376 12.111 16.5571 12.2097 16.5571C12.3085 16.5571 12.4063 16.5376 12.4975 16.4998C12.5887 16.4619 12.6715 16.4063 12.7412 16.3363C12.8819 16.1962 12.9614 16.0061 12.9621 15.8075C12.9628 15.6089 12.8847 15.4182 12.745 15.2771L10.763 13.2878C10.6233 13.1471 10.4335 13.0675 10.2353 13.0664Z"
                    fill="#fff"
                  ></path>
                  <path
                    d="M1.49923 2.62171C1.30058 2.6219 1.11013 2.70089 0.96967 2.84135C0.829205 2.98181 0.750198 3.17227 0.75 3.37091V13.8747C0.75 15.3796 2.08406 16.532 3.6214 16.532H5.75093C5.94957 16.5318 6.14003 16.4528 6.28049 16.3123C6.42095 16.1719 6.49995 15.9814 6.50015 15.7828C6.49995 15.5841 6.42095 15.3937 6.28049 15.2532C6.14003 15.1128 5.94957 15.0338 5.75093 15.0336H3.6214C2.8088 15.0336 2.25214 14.4854 2.25214 13.8747V3.37091C2.25204 3.27224 2.23247 3.17456 2.19455 3.08347C2.15664 2.99237 2.10113 2.90965 2.03118 2.84005C1.96124 2.77045 1.87824 2.71533 1.78696 2.67786C1.69568 2.6404 1.5979 2.62132 1.49923 2.62171ZM18.7644 11.7599C18.6654 11.7595 18.5673 11.7787 18.4758 11.8164C18.3843 11.8541 18.3011 11.9096 18.2311 11.9795C18.1611 12.0495 18.1057 12.1327 18.068 12.2242C18.0303 12.3157 18.0111 12.4138 18.0115 12.5128V13.8747C18.0115 14.4854 17.4548 15.0336 16.6422 15.0336H14.7489C14.5503 15.0338 14.3598 15.1128 14.2193 15.2532C14.0789 15.3937 13.9999 15.5841 13.9997 15.7828C13.9999 15.9814 14.0789 16.1719 14.2193 16.3123C14.3598 16.4528 14.5503 16.5318 14.7489 16.532H16.6422C18.1796 16.532 19.5136 15.3796 19.5136 13.8747V12.5128C19.514 12.4141 19.4949 12.3164 19.4574 12.2251C19.42 12.1338 19.3649 12.0508 19.2953 11.9809C19.2257 11.9109 19.1429 11.8554 19.0518 11.8175C18.9608 11.7796 18.8631 11.76 18.7644 11.7599Z"
                    fill="#fff"
                  ></path>
                  <path
                    d="M3.6214 0.713562C2.08514 0.713543 0.75 1.86619 0.75 3.37088C0.75 4.87556 2.08514 6.03188 3.6214 6.03188C3.82005 6.03168 4.01049 5.95269 4.15095 5.81223C4.29141 5.67177 4.37041 5.48131 4.37061 5.28267C4.37099 5.184 4.35191 5.08622 4.31444 4.99493C4.27697 4.90365 4.22186 4.82067 4.15226 4.75073C4.08266 4.68078 3.99994 4.62526 3.90885 4.58734C3.81775 4.54942 3.72008 4.52986 3.6214 4.52976C2.81475 4.52976 2.25214 3.97492 2.25214 3.37088C2.25214 2.76683 2.81475 2.21197 3.6214 2.21199H14.963C15.4851 2.21199 15.893 2.61991 15.893 3.14205V5.28267C15.8932 5.48131 15.9722 5.67177 16.1127 5.81223C16.2531 5.95269 16.4436 6.03168 16.6422 6.03188C16.7409 6.03227 16.8387 6.01318 16.93 5.97571C17.0212 5.93825 17.1042 5.88314 17.1742 5.81354C17.2441 5.74394 17.2996 5.66122 17.3376 5.57012C17.3755 5.47903 17.395 5.38134 17.3951 5.28267V3.14205C17.3951 1.8093 16.2957 0.713562 14.963 0.713562H3.6214Z"
                    fill="#fff"
                  ></path>
                </svg>
                <span className="shimmer"></span>
              </button>
            )}
            <button
              title="Balance"
              className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out  rounded-full text-text_Quaternary  px-3 bg-bg_Secondary-new2 flex items-center justify-center py-1 xs:py-1 sm:py-2  gap-1 shadow-[0_8px_30px_rgb(0,0,0,0.12)]  cursor-pointer"
              type="button"
              onClick={() => {
                setRightSideMenuOpen(true);
              }}
            >
              <span className="text-xs sm:text-base text-white font-semibold bg-transparent">
                <p className="nowrap">
                  {balance && balance.balance
                    ? getCurrencyFormat(balance.balance)
                    : 0}
                </p>
                {balance.liability ? (
                  <p className="text-[10px]">
                    Exp:
                    {balance && balance.liability
                      ? getCurrencyFormat(balance?.liability)
                      : 0}
                  </p>
                ) : (
                  ""
                )}
              </span>

              <SVG_UserIcon stroke="#fff" />
            </button>
          </div>
        ) : (
          <div
            className={`w-max  items-center justify-center gap-1 lg:rounded-full  flex  -lg:rounded`}
          >
            <LanguageChange />

            <button
              id="loginButton"
              className={`flex rounded-full border border-quaternary hover:opacity-100 w-max font-extrabold items-center justify-center py-2 bg-bg_Secondary-new2 lg:relative lg:gap-1 lg:pr-4 lg:pl-3 -lg:px-4`}
              onClick={() => {
                actions.setLoginNew(true);
              }}
            >
              <span
                className={`w-max text-text_LoginTextColor hidden lg:block`}
              >
                <SVG_LoginIcon stroke="#fff" />
              </span>
              <span className=" text-x lg:text-xxs text-text_LoginHeadercolor text-white font-normal font-lato md:font-semibold lg:text-xs md:text-sm xs:text-xs -lg:font-[800]">
                Log In
              </span>
            </button>

            {IS_B2C && IS_SIGNUP_SHOW && (
              <button
                className="flex rounded-full lg:border border-secondary gap-1 hover:opacity-100 w-max font-extrabold items-center justify-center lg:pr-4 lg:pl-3 py-2 -lg:px-4 bg-bg_Quaternary"
                onClick={() => {
                  actions.setLoginNew(true);
                  actions.setTab(2);
                }}
              >
                <span className=" w-max  hidden lg:block">
                  <SVG_AddUserIcon />
                </span>
                <span className=" text-x lg:text-xxs  text-text_Primary  md:text-text_Ternary font-lato md:font-semibold lg:text-xs md:text-sm  xs:text-xs">
                  Sign Up
                </span>
              </button>
            )}
          </div>
        )}
      </>
    );
  }, [auth, balance, isNotificationOpen]);

  return (
    <>
      <div ref={refScroll}>
        {messages && messages.length > 0 && notifications !== false ? (
          <div className="ion-toolbar__wrapper-desktop notification__desktop">
            <div className="notification__container">
              <div className="notification__container__marquee-desktop">
                {messages
                  .filter((e) => !e.Type || e.Type == "T")
                  .map((message) => (
                    <div
                      key={message.id}
                      className="notification__container__message-desktop"
                    >
                      {message.text}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <div
        id="header"
        title="header"
        className={`${pageInfo?.headerClass} w-full z-[100]`}
        // className={`fixed top-0 w-full z-[100]`}
        style={{ zIndex: "1000" }}
      >
        <header>
          <div className="flex flex-col">
            <div className=" flex bg-[#f2f2f2] flex-col shadow autoAnimate">
              {auth && hideNews && (
                <div className="w-full relative max-h-[32px] bg-bg_appBg overflow-hidden">
                  <div
                    className="flex justify-start items-center gap-4 pr-2 marquee-scroll"
                    role="marquee"
                    aria-live="polite"
                    aria-label="Notifications"
                    style={{
                      animationDuration: "25s",
                      animationPlayState: "running",
                    }}
                  >
                    {newsData?.map((item) => {
                      return (
                        <span
                          key={item?.heading}
                          className="flex items-center gap-x-1 p-1 rounded-lg min-w-max whitespace-nowrap bg-bg_text_brand_primary-mar text-transparent bg-clip-text text-sm sm:text-base font-medium"
                        >
                          {item?.heading}
                        </span>
                      );
                    })}
                  </div>
                  <svg
                    onClick={() => setHideNews(!hideNews)}
                    className="absolute top-0 right-0.5 h-full cursor-pointer hover:opacity-80 transition-opacity z-10"
                    height={28}
                    width={28}
                    aria-label="Close notifications"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fad"
                    data-icon="circle-xmark"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <g className="fa-duotone-group">
                      <path
                        fill="currentColor"
                        d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
                      />
                      <path
                        fill="white"
                        d="M209 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z"
                      />
                    </g>
                  </svg>
                </div>
              )}

              <div
                id="header_body"
                className={`w-full bg-headerBg h-[54px] lg:h-[72px] pr-[4px] md:px-4 flex items-center justify-between gap-1 ${
                  openSearch ? " py-[11px] " : ""
                }  relative `}
              >
                <div
                  id="logoContainer"
                  className={`logo flex w-full  ${
                    openSearch ? "justify-start" : " h-full md:w-fit"
                  } `}
                >
                  <div className=" flex items-center w-[40px] md:w-fit justify-center lg:hidden ">
                    <button
                      className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out bg-none border-none h-full flex items-center justify-center active:scale-150  w-[100%] shadow-none px-1 cursor-pointer"
                      type="button"
                      onClick={() => {
                        setLeftSideMenuOpen(true);
                      }}
                    >
                      <span>
                        <SVG_MenuIcon fill="#fff" />
                      </span>
                    </button>
                  </div>
                  {openSearch && (
                    <div className=" transition-all ease-in-out duration-300 origin-top-right  relative ml-2 w-full popUpOpenAnimation">
                      <input
                        id="searchEventsMobile"
                        className="relative z-1 bg-transparent text-text_Quaternary outline-none border-none focus-none w-full pr-6 font-lato"
                        autoComplete="off"
                        type="text"
                        value={searchValue}
                        onChange={(e) => hableSearchChange(e.target.value)}
                      />
                      {!searchValue && (
                        <label
                          htmlFor="searchEventsMobile"
                          className=" absolute  font-lato font-light ml-[2px] z-0 top-0 left-0 right-0 bottom-0 text-xs xs:text-base text-text_Quaternary flex items-center justify-start w-full"
                        >
                          Search Events(At least 3 letters)...
                        </label>
                      )}
                      <button
                        className=" pl-4 flex items-center justify-center opacity-95 hover:opacity:100 absolute top-1/2 right-1 active:scale-150 -translate-y-1/2"
                        aria-label="Cancel Search"
                        onClick={() => {
                          setOpenSearch(!openSearch);
                        }}
                      >
                        <SVG_CloseIcon fill={"#fff"} />
                      </button>
                      <SearchDesktop
                        closeOnMobile={() => {
                          setOpenSearch(false);
                        }}
                      />
                    </div>
                  )}
                  {!openSearch && (
                    <div className="flex items-center">
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          navigate("/");
                        }}
                      >
                        <img
                          // src="/assets/images/localhost/logo.png"
                          src={logo}
                          width="200px"
                          alt=""
                          className="hidden sm:block max-w-[150px] max-h-[44px]"
                        />
                        <img
                          // src="/assets/images/localhost/logo192.png"
                          src={logo}
                          width="200px"
                          className="sm:hidden mobileLogoHeight max-w-[115px]"
                          alt=""
                        />
                      </div>
                    </div>
                  )}
                  {/* {theme === "dark" ? (
                    <div
                      className="text-[25px] ms-2"
                      style={{
                        height: "auto",
                        marginTop: "auto",
                        marginBottom: "auto",
                      }}
                      onClick={() => {
                        setTheme(theme === "dark" ? "light" : "dark");
                      }}
                    >
                      ☀️
                    </div>
                  ) : ( */}
                  <img
                    className="ms-2"
                    onClick={() => {
                      setTheme(theme === "dark" ? DEFAULT_THEME : "dark");
                    }}
                    src={
                      theme === "dark" ? "/light-theme.svg" : "/dark-theme.svg"
                    }
                    width={30}
                  />
                  {/* )}{" "} */}
                </div>

                {!openSearch && (
                  <>
                    <div
                      id="searchBox"
                      className="text-text_Quaternary relative hidden max-w-96 font-lato lg:block flex-grow"
                    >
                      <div className=" relative w-full max-w-[450px]">
                        <input
                          className="peer w-full  appearance-none text-xs pl-9 py-3  rounded-full md:text-[14px]  bg-bg_Quaternary  text-text_Ternary "
                          placeholder="Search Events(At least 3 letters)..."
                          type="text"
                          value={searchValue}
                          onChange={(e) => hableSearchChange(e.target.value)}
                        />
                        <SVG_SearchIcon />
                      </div>
                      {searchValue && (
                        <SearchDesktop closeOnMobile={() => {}} />
                      )}
                    </div>
                    <TimeSettingsDesktop />

                    {auth && (
                      <>
                        <div
                          id="loginName"
                          className=" text-text_Quaternary text-[10px] lg:text-[12px] xl:flex flex-col px-2 hidden"
                        >
                          <div className="flex gap-0.5 text-white/80  text-nowrap whitespace-nowrap">
                            Login as
                            <span className="font-medium text-text_Quaternary1">
                              {user && user?.name && user?.name}
                            </span>
                          </div>
                          <div className="flex  gap-0.5 text-white/80  text-nowrap whitespace-nowrap">
                            Last logged in
                            <span className="font-medium text-text_Quaternary1">
                              {lastLoggedIn}
                            </span>
                          </div>
                        </div>

                        <div
                          id="loginName"
                          className=" text-text_Quaternary text-[10px] lg:text-[12px] lg:flex flex-col px-2 hidden"
                        >
                          <div className="flex gap-0.5 text-white/80  xl:text-nowrap whitespace-nowrap">
                            {/* Available balance: */}
                            Balance:
                            <span className="font-medium text-text_Quaternary1">
                              {" "}
                              {balance && balance.balance
                                ? getCurrencyFormat(balance.balance)
                                : 0}
                            </span>
                          </div>
                          {balance.liability ? (
                            <p className="text-xs text-white/80">
                              Exposure:
                              {balance && balance.liability
                                ? getCurrencyFormat(balance?.liability)
                                : 0}
                            </p>
                          ) : (
                            ""
                          )}
                        </div>

                        <div
                          id="deposit_withdraw_btn"
                          className=" hidden lg:flex items-center justify-center gap-1"
                        >
                          {IS_B2C && (
                            <button
                              className="inline-block  leading-normal relative overflow-hidden  transition duration-150 ease-in-out bg-none border-none shadow-none cursor-pointer"
                              type="button"
                              onClick={() => {
                                if (userData?.is_demo) {
                                  toastr.error(
                                    "",
                                    "Please login from your read ID.",
                                  );
                                } else {
                                  navigate("/deposit");
                                }
                              }}
                            >
                              <span className="text-white capitalize border  flex rounded px-3 py-1  flex-col text-[10px]  hover:opacity-100 w-max font-semibold items-center justify-center  bg-bg_HeaderDepositBtnBgColor border-depositBtn ">
                                <SVG_DepositIcon stroke="#ffffff" />
                                deposit
                              </span>
                            </button>
                          )}
                          {IS_B2C && (
                            <button
                              className="inline-block  leading-normal relative overflow-hidden  transition duration-150 ease-in-out bg-none border-none shadow-none  cursor-pointer"
                              type="button"
                              onClick={() => {
                                if (userData?.is_demo) {
                                  toastr.error(
                                    "",
                                    "Please login from your read ID.",
                                  );
                                } else {
                                  navigate("/withdraw");
                                }
                              }}
                            >
                              <span className="text-white capitalize   flex rounded px-3 py-1  flex-col text-[10px]  hover:opacity-100 w-max font-semibold items-center justify-center  bg-bg_HomeWithdrawBtnBgColor  ">
                                <SVG_WithdrawIcon stroke="#ffffff" />
                                withdraw
                              </span>
                            </button>
                          )}
                        </div>

                        <div className=" w-max hidden items-center justify-center gap-1 rounded-full  lg:flex">
                          {memoizedNotification}

                          {!userData?.is_demo && IS_B2C && (
                            <button
                              className="inline-block  leading-normal relative overflow-hidden  transition duration-150 ease-in-out bg-none border-none shadow-none cursor-pointer"
                              type="button"
                              onClick={() => {
                                navigate("/affiliate");
                              }}
                            >
                              <span className="text-white capitalize border  flex rounded px-3 py-1  flex-col text-[10px]  hover:opacity-100 w-max font-semibold items-center justify-center  bg-bg_HeaderDepositBtnBgColor border-depositBtn ">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 21 21"
                                  fill="none"
                                >
                                  <g clipPath="url(#clip0_2_27154)">
                                    <path
                                      d="M5.41956 2.33087C5.53248 2.22009 5.68648 2.15784 5.84691 2.15784C6.00735 2.15784 6.16119 2.22025 6.27427 2.33102L8.05331 4.07541C8.17108 4.19077 8.32744 4.2544 8.49336 4.2544C8.61977 4.2544 11.6435 4.2544 12.1735 4.2544C12.3395 4.2544 12.4957 4.19077 12.6146 4.0745L14.3624 2.36917C14.4754 2.25885 14.6289 2.1969 14.7889 2.1969C14.789 2.1969 14.7893 2.1969 14.7895 2.1969C14.9498 2.19705 15.1033 2.25946 15.2162 2.37009L20.4208 7.47141C20.6543 7.7003 20.6539 8.06971 20.4197 8.29814L18.927 9.75322C18.6443 10.0305 18.4886 10.3993 18.4886 10.7919C18.4886 11.2999 18.3421 11.7857 18.0698 12.2042C18.6623 12.9052 18.6241 13.9492 17.9544 14.6055C17.6302 14.9234 17.2057 15.1071 16.7504 15.1287C16.7296 15.5572 16.5527 15.9796 16.2196 16.306C15.8954 16.6238 15.4709 16.8075 15.0155 16.8292C14.9948 17.2577 14.8177 17.68 14.4848 18.0064C13.9605 18.5203 13.2082 18.6499 12.5729 18.4279C12.4854 18.6738 12.3417 18.9045 12.1416 19.1006C11.4267 19.8016 10.2672 19.8018 9.5521 19.1006L9.29788 18.8516C9.13902 18.6958 9.01591 18.518 8.92809 18.3284C8.21688 18.9398 7.12066 18.9262 6.42764 18.2469C6.09454 17.9205 5.91764 17.4981 5.89694 17.0697C5.44167 17.0482 5.01699 16.8643 4.69282 16.5464C4.35972 16.2201 4.18283 15.7977 4.16197 15.3692C3.70686 15.3477 3.28217 15.1638 2.95801 14.8462C2.29212 14.1935 2.25025 13.1573 2.83239 12.4563C2.40817 11.8748 2.17842 11.1807 2.17842 10.4518C2.17842 10.281 2.10801 10.1141 1.98521 9.9937L0.214951 8.25785C-0.0180931 8.02943 -0.0180931 7.66078 0.214951 7.43235L5.41956 2.33087ZM17.0995 12.9051L16.2321 12.0549C15.9886 11.8161 15.5959 11.8159 15.3522 12.0549C15.106 12.2961 15.106 12.6886 15.3522 12.9296L16.2196 13.78C16.4633 14.0188 16.8558 14.0188 17.0995 13.78C17.3456 13.5388 17.3456 13.1463 17.0995 12.9051ZM15.3647 14.6055L13.6299 12.9051C13.3862 12.6663 12.9935 12.6661 12.7498 12.9051C12.5037 13.1463 12.5037 13.5388 12.7498 13.78C13.3682 14.3861 13.4011 14.4183 14.4848 15.4805C14.7285 15.7191 15.121 15.7193 15.3647 15.4803C15.6108 15.2392 15.6108 14.8468 15.3647 14.6055ZM13.6299 17.1808C13.876 16.9397 13.876 16.5472 13.6299 16.306L12.7625 15.4557C12.5188 15.2169 12.1261 15.2169 11.8824 15.4557C11.6551 15.6785 11.6382 16.0299 11.8308 16.2725C11.8838 16.3202 11.8049 16.2436 12.7498 17.1808C12.9935 17.4197 13.386 17.4199 13.6299 17.1808ZM10.1526 18.0259L10.4068 18.275C10.6505 18.5139 11.0431 18.5139 11.2868 18.275C11.511 18.0552 11.5303 17.7102 11.3459 17.4682C11.0153 17.1431 11.0314 17.1623 10.9739 17.1009C10.728 16.9128 10.3769 16.9314 10.1526 17.1511C9.90653 17.3924 9.90669 17.7848 10.1526 18.0259ZM3.81271 14.0205C4.05642 14.2593 4.44912 14.2593 4.69282 14.0205L5.81429 12.9213C6.04859 12.6916 6.42999 12.6902 6.66602 12.9182C6.90204 13.1462 6.90345 13.5171 6.66916 13.7468L5.54753 14.846C5.30147 15.0872 5.30147 15.4797 5.54753 15.7208C5.79124 15.9597 6.18393 15.9597 6.42764 15.7208L7.54911 14.6215C7.78357 14.3919 8.16481 14.3905 8.40084 14.6185C8.63686 14.8465 8.63827 15.2176 8.40397 15.4472L7.2825 16.5464C7.03629 16.7877 7.03629 17.1801 7.2825 17.4212C7.52606 17.6602 7.91875 17.6602 8.16262 17.4212C9.34321 16.2735 9.28659 16.2986 9.40547 16.2288C9.71222 15.9718 10.0922 15.8229 10.4971 15.8027C10.5189 15.3759 10.6958 14.9554 11.0275 14.6301C11.1977 14.4635 11.3956 14.3338 11.6109 14.245C11.2025 13.5609 11.2971 12.6655 11.8951 12.0796C12.508 11.4788 13.4248 11.4061 14.1084 11.7956C14.197 11.5898 14.3264 11.3967 14.4973 11.2294C15.2124 10.5284 16.3717 10.5284 17.087 11.2294L17.183 11.3235C17.2492 11.1563 17.2841 10.9767 17.2841 10.7919C17.2841 10.0878 17.5641 9.42592 18.0734 8.92649L19.1438 7.8831L14.7879 3.61353L13.4684 4.90091C13.1735 5.18992 12.7954 5.36768 12.3869 5.41376L15.078 8.55571C15.2909 8.80442 15.2564 9.17384 15.0009 9.3809C14.3831 9.88185 13.6018 10.1188 12.8009 10.048C12.0002 9.97722 11.2755 9.60719 10.76 9.00523C10.5443 8.75346 10.1816 8.67762 9.87752 8.82045C9.25695 9.11219 8.57491 9.2187 7.90401 9.13539L3.81271 13.1456C3.56665 13.3868 3.56665 13.7793 3.81271 14.0205ZM2.83992 9.16804C3.19011 9.51121 3.38285 9.96715 3.38285 10.4518C3.38285 10.8607 3.49185 11.2529 3.69541 11.5971L6.62446 8.7263C6.02569 8.4022 5.53467 7.91499 5.20894 7.31104C5.05447 7.02448 5.16801 6.67033 5.46253 6.52003C5.75705 6.36958 6.12105 6.48005 6.27552 6.76661C6.60235 7.37269 7.16332 7.7772 7.79172 7.92704C7.81932 7.93116 7.84677 7.93696 7.87358 7.9449C8.35645 8.04209 8.87414 7.99067 9.35356 7.7653C10.1564 7.38795 11.115 7.58937 11.6859 8.25587C11.9948 8.61644 12.4296 8.83845 12.9099 8.88102C13.183 8.90513 13.4521 8.86958 13.7017 8.7794L10.9138 5.52393C10.6954 5.45908 10.4689 5.42124 10.2406 5.42124H8.49336C8.00406 5.42124 7.54425 5.23966 7.19845 4.90091L5.84676 3.57553L1.49074 7.8451L2.83992 9.16804Z"
                                      fill="#fff"
                                    ></path>
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_2_27154">
                                      <rect
                                        width="20.5556"
                                        height="20"
                                        fill="white"
                                        transform="matrix(-1 0 0 1 20.5555 0.868774)"
                                      ></rect>
                                    </clipPath>
                                  </defs>
                                </svg>
                                Affiliate
                              </span>
                            </button>
                          )}

                          <button
                            className="relative flex rounded-full gap-1 border border-quaternary hover:opacity-100 w-max font-extrabold items-center justify-center pr-4 pl-3 py-2 bg-bg_Secondary-new2"
                            onClick={() => {
                              setRightSideMenuOpen(true);
                            }}
                          >
                            <span className=" w-max text-text_LoginTextColor hidden md:block">
                              <SVG_SettingIcon />
                            </span>
                            <span className=" text-xxs text-text_LoginTextColor  md:text-text_LoginTextColor  font-normal font-lato md:font-semibold md:text-xs xs:text-xs ">
                              Account
                            </span>
                          </button>

                          <LanguageChange />
                        </div>

                        {/* <button
                          id="theme-toggle"
                          onClick={() => {
                            setTheme(theme === "dark" ? "light" : "dark");
                          }}
                          type="button"
                          className={`cursor-pointer  hidden sm:inline-flex   w-[30] h-[30] ${theme === "dark" ? "text-gray-300 border-gray-300" : "text-gray-100 border-gray-200"} border-2 rounded-lg text-sm p-1`}
                        >
                          <svg
                            id="theme-toggle-dark-icon"
                            className={`${theme === "dark" ? "hidden" : ""} w-5 h-5`}
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"></path>
                          </svg>
                          <svg
                            id="theme-toggle-light-icon"
                            className={`${theme === "dark" ? "" : "hidden"} w-5 h-5`}
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                              fillRule="evenodd"
                              clipRule="evenodd"
                            ></path>
                          </svg>
                        </button> */}
                      </>
                    )}

                    <div className=" w-max flex items-center justify-center">
                      {/* <div
                        id="mobileSearchIcon"
                        className=" lg:hidden mr-[2px] flex items-center justify-center"
                        onClick={() => {
                          setOpenSearch(!openSearch);
                        }}
                      >
                        <span className="bg-none border-none shadow-none px-1">
                          <SVG_SearchIcon
                            width={20}
                            height={20}
                            fill={"#fff"}
                            className={""}
                          />
                        </span>
                      </div> */}

                      {memoizedRightMenu}

                      {/* {!auth && (
                        <button
                          id="theme-toggle"
                          onClick={() => {
                            setTheme(theme === "dark" ? "light" : "dark");
                          }}
                          type="button"
                          className={`ms-1 hidden sm:inline-flex  cursor-pointer w-[30] h-[30] ${theme === "dark" ? "text-gray-300 border-gray-300" : "text-gray-100 border-gray-200"} border-2 rounded-lg text-sm p-1`}
                        >
                          <svg
                            id="theme-toggle-dark-icon"
                            className={`${theme === "dark" ? "hidden" : ""} w-5 h-5`}
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"></path>
                          </svg>
                          <svg
                            id="theme-toggle-light-icon"
                            className={`${theme === "dark" ? "" : "hidden"} w-5 h-5`}
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                              fillRule="evenodd"
                              clipRule="evenodd"
                            ></path>
                          </svg>
                        </button>
                      )} */}
                    </div>
                  </>
                )}
              </div>
              {/* w-[calc(100%-30px)] 
md:w-full  */}

              <div className="relative">
                <div
                  className="flex  overflow-x-auto no-scrollbar 
                  
w-full 
     bg-bg_Quaternary p-1 items-start md:items-center md:justify-center "
                >
                  <Link to={"/"}>
                    <button
                      className={`text-xs  cursor-pointer uppercase hide-border-in-dark mr-1 active:border-primary hide-border-in-dark rounded-full text-nowrap whitespace-nowrap font-semibold bg-bg_Ternary8 hover:bg-bg_Ternary9 border w-max px-3  py-1  text-text_HeaderDeskNavMenu  md:hidden ${
                        location.pathname === "/"
                          ? "border-primary text-active-new"
                          : ""
                      }`}
                      // className="text-xs cursor-pointer uppercase mr-1 active:border-primary hide-border-in-dark rounded-full text-nowrap whitespace-nowrap font-semibold bg-bg_Ternary8 hover:bg-bg_Ternary9 border w-max px-3  py-1  text-text_HeaderDeskNavMenuHover  md:hidden "
                    >
                      <span className=" flex flex-row items-center justify-center gap-1">
                        <SVG_HomeIcon
                          fill={"var(--color-text-ternary)"}
                          width={16}
                          height={16}
                        />
                        <span className="font font-lato text-[12px]">Home</span>
                      </span>
                    </button>
                  </Link>

                  <Link to={"/sports-page/Sportsbook/0"}>
                    <button
                      className={`text-xs cursor-pointer uppercase border mr-1 hide-border-in-dark
                        active:border-primary   rounded-full text-nowrap whitespace-nowrap f
                        ont-semibold bg-bg_Ternary8 hover:bg-bg_Ternary9  w-max px-3  py-1 
                        text-text_HeaderDeskNavMenu ${location.pathname === "/sports-page/Sportsbook/0" ? "border-primary text-active-new" : ""}`}
                      to={"/sports-page/Sportsbook/0"}
                      onClick={() => {
                        actions.setIsNavigationID("0");
                        actions.setIsNavigationName("Sportsbook");
                      }}
                    >
                      <span className="flex w-full items-center h-full gap-3">
                        <span className=" flex flex-row items-center justify-center">
                          {/* <span className="md:hidden"> */}
                          {/* <SVG_HomeIcon width={16} height={16} /> */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 576 512"
                            fill="currentColor"
                            height="16"
                            width="16"
                          >
                            <path d="M400 0L176 0c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8L24 64C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9L192 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-26.1 0C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24L446.4 64c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112l84.4 0c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6l84.4 0c-5.1 66.3-31.1 111.2-63 142.3z"></path>
                          </svg>
                          {/* </span> */}
                          <span className="font font-lato text-[12px] ml-[4px]">
                            SPORTS
                          </span>
                        </span>
                      </span>
                    </button>
                  </Link>

                  {isSportAvailable("4") && (
                    <Link to={"/sports-page/Cricket/4"}>
                      <button
                        className={`text-xs  gap-1 cursor-pointer uppercase mr-1 active:border-primary hide-border-in-dark rounded-full text-nowrap whitespace-nowrap font-semibold bg-bg_Ternary8 hover:bg-bg_Ternary9 border w-max px-2  py-1  text-text_HeaderDeskNavMenu  hidden md:flex ${
                          ["sports-page/Cricket", "event-page/4"].some((path) =>
                            location.pathname.includes(path),
                          )
                            ? "border-primary text-active-new"
                            : ""
                        }`}
                        onClick={() => {
                          actions.setIsNavigationID("4");
                          actions.setIsNavigationName("Cricket");
                        }}
                      >
                        <svg
                          width={16}
                          height={16}
                          viewBox="0 0 19 18"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="var(--cricket-icon-color)"
                        >
                          <path
                            d="M4.36255 16.7108C4.35063 16.7037 4.34109 16.6966 4.32917 16.6895C3.88333 16.4077 3.4518 16.107 3.05842 15.7566C2.91299 15.6263 2.77709 15.489 2.63404 15.3564C2.59828 15.3256 2.61974 15.3067 2.63642 15.283C2.81524 15.0533 2.99643 14.8213 3.17524 14.5916C3.92148 13.635 4.6701 12.676 5.41634 11.7194C6.27225 10.6231 7.12578 9.52678 7.98169 8.43047C8.8066 7.37204 9.6339 6.31125 10.4588 5.25282C11.329 4.14231 12.1969 3.02942 13.0647 1.9189C13.2292 1.70816 13.3961 1.49506 13.5582 1.28195C13.5797 1.25354 13.5916 1.24644 13.6274 1.26538C13.9468 1.45244 14.2472 1.67028 14.5333 1.90233C14.6692 2.01125 14.8123 2.1107 14.9458 2.22199C15.0817 2.34038 15.2128 2.46351 15.3439 2.58663C15.3773 2.61742 15.3535 2.63162 15.3368 2.65293C15.1008 2.95602 14.8623 3.26147 14.6263 3.56455C13.9254 4.46433 13.222 5.36411 12.5211 6.26389C11.7343 7.27259 10.9476 8.28129 10.1584 9.29C9.42648 10.2277 8.69693 11.1653 7.965 12.103C7.12101 13.1827 6.2794 14.2648 5.43542 15.3446C5.08971 15.7874 4.7464 16.2278 4.40069 16.6706C4.39116 16.6848 4.38401 16.7037 4.36255 16.7108Z"
                            fill="var(--cricket-icon-color)"
                          />
                          <path
                            d="M17.9928 8.49706C17.9761 8.16556 17.9451 7.83643 17.8927 7.50967C17.8283 7.11424 17.7305 6.72591 17.6137 6.33995C17.3777 5.55146 17.0225 4.8198 16.5814 4.12365C16.4336 3.89161 16.2762 3.66903 16.1022 3.45119C16.0879 3.46776 16.0736 3.48197 16.0617 3.49854C15.7231 3.93423 15.3869 4.36991 15.0484 4.80322C14.2426 5.84271 13.4367 6.88219 12.6309 7.92167C11.7988 8.99431 10.9691 10.0669 10.1371 11.1372C9.34792 12.1554 8.55639 13.1759 7.76724 14.1941C6.99001 15.1981 6.2104 16.202 5.43317 17.2036C5.40456 17.2391 5.40695 17.251 5.44986 17.2699C6.43213 17.6867 7.45492 17.9211 8.52063 17.9803C9.05468 18.0087 9.58872 17.9921 10.1204 17.9258C10.571 17.869 11.0144 17.7814 11.4483 17.6511C12.247 17.412 13.0052 17.0852 13.7157 16.6495C14.4619 16.1925 15.1247 15.6385 15.7112 14.9897C16.0998 14.5587 16.4455 14.097 16.7411 13.5998C17.1917 12.8421 17.5136 12.0346 17.7353 11.1846C17.8736 10.6518 17.9594 10.1096 17.988 9.56022C18.0095 9.20741 18.0119 8.85224 17.9928 8.49706ZM9.17865 15.8587C8.93547 16.1618 8.70182 16.472 8.46579 16.7821C8.3299 16.9621 8.15586 17.0473 7.92936 16.9952C7.69572 16.9408 7.54552 16.7443 7.5479 16.5051C7.54552 16.382 7.58843 16.2754 7.66472 16.1783C7.90075 15.8776 8.13678 15.5745 8.37281 15.2738C8.52778 15.0797 8.7805 15.0063 8.98792 15.1128C9.31931 15.2809 9.336 15.6598 9.17865 15.8587ZM11.105 13.2612C11.0955 13.3606 11.055 13.4435 10.9954 13.5216C10.7569 13.8271 10.5233 14.1349 10.2873 14.4403C10.1633 14.6014 10.0012 14.6795 9.79853 14.644C9.58157 14.6061 9.44567 14.4688 9.39322 14.2557C9.38369 14.2201 9.38369 14.1823 9.3813 14.1444C9.3813 14.026 9.42183 13.9194 9.49336 13.8271C9.73654 13.5169 9.97972 13.2043 10.2253 12.8941C10.3588 12.726 10.6115 12.6621 10.807 12.7426C10.9977 12.8231 11.1265 13.0457 11.105 13.2612ZM12.8407 11.1443C12.5927 11.4569 12.3519 11.7742 12.0992 12.082C11.98 12.2264 11.8131 12.3069 11.6176 12.2643C11.4078 12.2169 11.2695 12.082 11.2242 11.8689C11.1932 11.7268 11.2266 11.5918 11.3172 11.4734C11.5485 11.1704 11.7845 10.872 12.0134 10.5666C12.2494 10.2493 12.7501 10.28 12.9098 10.666C12.936 10.7276 12.9432 10.7915 12.9432 10.8554C12.9432 10.9644 12.9098 11.0591 12.8407 11.1443ZM14.6645 8.77646C14.419 9.09139 14.1758 9.41105 13.9326 9.72834C13.7991 9.90119 13.5678 9.97459 13.358 9.90829C13.1602 9.84673 13.0195 9.66204 13.0123 9.44656C13.0076 9.31633 13.0576 9.19794 13.1363 9.09849C13.3747 8.79067 13.6203 8.48996 13.8635 8.18687C14.0018 8.01639 14.2235 7.95009 14.4238 8.02112C14.624 8.09216 14.7575 8.27922 14.7599 8.49943C14.7528 8.59414 14.7313 8.69122 14.6645 8.77646ZM16.5099 6.40152C16.2667 6.71644 16.0235 7.03373 15.7827 7.34866C15.6254 7.55466 15.4084 7.62333 15.1795 7.53808C14.9888 7.46705 14.86 7.27288 14.8648 7.03847C14.8624 6.94375 14.9077 6.8372 14.9816 6.74012C15.2153 6.44177 15.4465 6.14342 15.6826 5.84508C15.8638 5.61303 16.1308 5.56804 16.3835 5.72432C16.5933 5.85691 16.6601 6.20736 16.5099 6.40152Z"
                            fill="var(--cricket-icon-color)"
                          />
                          <path
                            d="M12.5188 0.709924C11.5127 0.274241 10.4589 0.0469281 9.36222 0.00667475C8.58975 -0.0217394 7.82444 0.0398245 7.06866 0.205573C6.33911 0.364219 5.63817 0.605739 4.97299 0.94434C3.79522 1.54104 2.7915 2.35084 1.96896 3.38559C1.49213 3.98702 1.09398 4.63344 0.784041 5.33432C0.469333 6.04467 0.245222 6.78581 0.116478 7.55062C0.0592586 7.88212 0.0306488 8.21598 0.0163439 8.54985C0.00203901 8.85057 0.00203901 9.14891 0.0163439 9.44963C0.0282647 9.72904 0.0521062 10.0108 0.0902526 10.2878C0.142704 10.6738 0.233302 11.0527 0.338204 11.4268C0.457412 11.8577 0.602845 12.2816 0.791193 12.6888C0.979541 13.0937 1.19888 13.4821 1.4373 13.8609C1.57796 14.0835 1.72816 14.2966 1.89029 14.5097C5.44744 9.91609 8.99982 5.32248 12.5522 0.733602C12.5451 0.717027 12.5308 0.71466 12.5188 0.709924ZM3.05375 11.1379C2.81057 11.4505 2.56739 11.7654 2.31943 12.0732C2.17162 12.2579 1.91651 12.3171 1.70909 12.2082C1.45637 12.0732 1.3014 11.7441 1.5279 11.4741C1.61134 11.3747 1.68525 11.2681 1.76393 11.1639C1.92366 10.9532 2.07863 10.7377 2.24076 10.5294C2.37427 10.3565 2.55308 10.2831 2.77004 10.3328C2.987 10.3826 3.11097 10.5246 3.15627 10.7401C3.15865 10.7472 3.15865 10.7567 3.16104 10.7638C3.16104 10.7851 3.16104 10.8064 3.16104 10.8277C3.16342 10.9414 3.12528 11.0456 3.05375 11.1379ZM4.8824 8.78427C4.68213 9.03999 4.48186 9.29809 4.28159 9.55382C4.24583 9.60117 4.21006 9.64853 4.17192 9.69352C4.06463 9.82849 3.91681 9.89952 3.6784 9.89715C3.5282 9.89242 3.38753 9.77166 3.29932 9.5917C3.21349 9.42122 3.24687 9.2602 3.36369 9.10866C3.60449 8.79611 3.83814 8.47882 4.07655 8.16389C4.20291 7.99814 4.37457 7.92711 4.57722 7.96263C4.78226 7.99814 4.91816 8.1189 4.97538 8.32254C5.02544 8.49302 4.98968 8.64693 4.8824 8.78427ZM6.69673 6.43063C6.4607 6.73372 6.22467 7.03443 5.98864 7.33515C5.85275 7.508 5.66917 7.55772 5.46413 7.508C5.27101 7.46064 5.14704 7.32804 5.09697 7.13625C5.05882 6.98471 5.09935 6.84264 5.18995 6.72424C5.4379 6.40222 5.69301 6.08729 5.95049 5.77C6.07209 5.62083 6.23659 5.5711 6.42017 5.61136C6.61806 5.65398 6.74203 5.78421 6.79687 5.98074C6.80879 6.02099 6.81117 6.06125 6.80879 6.11571C6.81594 6.227 6.77303 6.33355 6.69673 6.43063ZM8.59452 3.9515C8.52538 4.09831 8.41332 4.21433 8.31796 4.33983C8.15107 4.55767 7.98179 4.77551 7.81013 4.98862C7.68139 5.14963 7.50496 5.21119 7.30708 5.17094C7.09727 5.12832 6.96138 4.99572 6.91369 4.78498C6.90654 4.75183 6.90654 4.71395 6.90177 4.67843C6.90416 4.5553 6.95422 4.45348 7.02575 4.35877C7.25701 4.05332 7.49066 3.75023 7.72669 3.44715C7.88166 3.24825 8.13199 3.17722 8.34657 3.2814C8.6279 3.42347 8.71134 3.70288 8.59452 3.9515ZM10.3683 1.70679C10.1299 2.02408 9.88673 2.33663 9.64355 2.65155C9.5148 2.8173 9.28115 2.8836 9.08089 2.81967C8.88062 2.75574 8.74234 2.57105 8.73518 2.35557C8.7328 2.22534 8.78287 2.10695 8.85678 2.00513C9.09042 1.69495 9.32884 1.38713 9.56725 1.07931C9.665 0.953812 9.79852 0.885144 9.97494 0.878041C10.1704 0.894616 10.3254 0.998801 10.4232 1.17639C10.5281 1.36108 10.4899 1.54577 10.3683 1.70679Z"
                            fill="var(--cricket-icon-color)"
                          />
                        </svg>

                        <span className="font font-lato text-[12px]">
                          Cricket
                        </span>
                      </button>
                    </Link>
                  )}
                  {isSportAvailable("1") && (
                    <Link to={"/sports-page/football/1"}>
                      <button
                        className={`text-xs gap-1 cursor-pointer uppercase mr-1 active:border-primary hide-border-in-dark rounded-full text-nowrap whitespace-nowrap font-semibold bg-bg_Ternary8 hover:bg-bg_Ternary9 border w-max px-2  py-1  text-text_HeaderDeskNavMenu  hidden md:flex ${
                          ["sports-page/football", "event-page/1"].some(
                            (path) => location.pathname.includes(path),
                          )
                            ? "border-primary text-active-new"
                            : ""
                        }`}
                        onClick={() => {
                          actions.setIsNavigationID("1");
                          actions.setIsNavigationName("Football");
                        }}
                      >
                        <SVG_FootballIcon width={16} height={16} />
                        <span className="font font-lato text-[12px]">
                          Football
                        </span>
                      </button>
                    </Link>
                  )}
                  {isSportAvailable("2378961") && (
                    <Link to={"/election"}>
                      <button
                        className={`text-xs cursor-pointer uppercase mr-1 active:border-primary hide-border-in-dark rounded-full text-nowrap whitespace-nowrap font-semibold bg-bg_Ternary8 hover:bg-bg_Ternary9 border w-max px-3  py-1  text-text_HeaderDeskNavMenu  hidden md:block ${
                          location.pathname.includes("election")
                            ? "border-primary text-active-new"
                            : ""
                        }`}
                      >
                        <span className="font font-lato text-[12px]">
                          Election
                        </span>
                      </button>
                    </Link>
                  )}
                  {isSportAvailable("2") && (
                    <Link to={"/sports-page/tennis/2"}>
                      <button
                        className={`text-xs cursor-pointer uppercase mr-1 active:border-primary hide-border-in-dark rounded-full text-nowrap whitespace-nowrap font-semibold bg-bg_Ternary8 hover:bg-bg_Ternary9 border w-max px-3  py-1  text-text_HeaderDeskNavMenu  hidden md:flex gap-1 ${
                          ["sports-page/tennis", "event-page/2"].some((path) =>
                            location.pathname.includes(path),
                          )
                            ? "border-primary text-active-new"
                            : ""
                        }`}
                        onClick={() => {
                          actions.setIsNavigationID("2");
                          actions.setIsNavigationName("Tennis");
                        }}
                      >
                        {" "}
                        <SVG_TennisIcon width={18} height={18} />
                        <span className="font font-lato text-[12px]">
                          Tennis
                        </span>
                      </button>
                    </Link>
                  )}
                  {isSportAvailable("7") && (
                    <Link to={"/horse-racing"}>
                      <button
                        className={`text-xs gap-1 cursor-pointer uppercase mr-1 active:border-primary hide-border-in-dark rounded-full text-nowrap whitespace-nowrap font-semibold bg-bg_Ternary8 hover:bg-bg_Ternary9 border w-max px-3  py-1  text-text_HeaderDeskNavMenu  hidden md:flex ${
                          location.pathname.includes("horse-racing")
                            ? "border-primary text-active-new"
                            : ""
                        }`}
                        onClick={() => {
                          const horseRacing = { sport_id: "7" };

                          getMenu(horseRacing);
                          actions.setIsNavigationID("7");
                          actions.setIsNavigationName("Horse Racing");
                        }}
                      >
                        <svg
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlSpace="preserve"
                          viewBox="10.35099 0 170.59965 192.83511000000001"
                          y={0}
                          x={0}
                          width={20}
                          height={20}
                          fill="#fff"
                          className="w-[16px] h-[16px]"
                        >
                          <g transform="translate(-.981 -.981)scale(1.01)">
                            <path
                              opacity={1}
                              // fill="#864D44"
                              fill="var(--horse-icon-color)"
                              d="M37.332 151.44c-25.932 -38.27 -7.631 -68.158 -7.631 -68.158 -4.252 -1.259 -17.851 7.653 -17.851 7.653 7.648 -28.029 49.717 -51.843 49.717 -51.843 -4.67 -1.709 -17.845 1.686 -17.845 1.686 34.417 -33.124 76.49 -20.807 76.49 -20.807C121.482 12.742 142.314 0 142.314 0c-2.131 2.11 -2.99 13.6 -2.99 13.6 2.125 -3.83 8.936 -7.653 8.936 -7.653 -3.821 8.912 0 28.03 0 28.03 11.047 11.057 23.366 49.307 23.366 49.307l4.688 6.797c5.951 8.511 3.764 21.892 -2.131 25.065 -22.09 11.926 -24.227 -9.767 -24.227 -9.767 -18.274 -2.125 -31.874 -22.529 -31.874 -22.529 -24.639 12.745 -10.916 48.7 -0.277 62.507 13.669 17.698 3.66 46.328 3.66 46.328s-58.527 -2.424 -84.133 -40.244"
                            />
                          </g>
                        </svg>

                        <span className="font font-lato text-[12px]">
                          Horse
                        </span>
                      </button>
                    </Link>
                  )}
                  {isSportAvailable("4339") && (
                    <Link to={"/greyhound-racing"}>
                      <button
                        className={`text-xs gap-1 cursor-pointer uppercase mr-1 active:border-primary hide-border-in-dark rounded-full text-nowrap whitespace-nowrap font-semibold bg-bg_Ternary8 hover:bg-bg_Ternary9 border w-max px-3  py-1  text-text_HeaderDeskNavMenu  hidden md:flex ${
                          location.pathname.includes("greyhound-racing")
                            ? "border-primary text-active-new"
                            : ""
                        }`}
                        onClick={() => {
                          const horseRacing = { sport_id: "4339" };

                          getMenu(horseRacing);
                          actions.setIsNavigationID("4339");
                          actions.setIsNavigationName("Greyhound Racing");
                        }}
                      >
                        {/* <img
                          src={SVG_GreyhoundIcon}
                          className={`${theme === "dark" ? "invert" : ""}`}
                          width={16}
                          height={16}
                        /> */}
                        <svg
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlSpace="preserve"
                          viewBox="0.8406520000000001 94.153024 422.847956 233.70125600000003"
                          y={0}
                          x={0}
                          version="1.1"
                          width={16}
                          height={16}
                          fill="currentColor"
                        >
                          <g>
                            <path
                              opacity={1}
                              fill="currentColor"
                              d="M228.053 116.191c.479.052-.456-.124 0 0z"
                            />
                            <path
                              opacity={1}
                              fill="currentColor"
                              d="m415.501 229.82-101.146-52.965c-2.592-11.371-8.942-25.952-24.06-38.143-15.015-12.109-35.906-19.814-62.242-22.521L27.658 94.656a8.995 8.995 0 0 0-9.797 7.198c-.113.571-2.711 14.166 2.438 30.739 2.181 7.02 5.985 15.256 12.577 23.378l-26.269 7.247A8.999 8.999 0 0 0 .21 173.822c.122.556 3.114 13.764 14.148 26.747 7.718 9.082 20.66 19.491 41.182 23.883-18.63 40.612-24.831 77.128-25.109 78.809a9 9 0 0 0 7.96 10.424l116.955 11.99a9.002 9.002 0 0 0 9.635-6.712c6.019-23.404 17.513-54.518 47.719-54.518 15.748 0 33.407 7.798 48.724 15.107 21.949 10.475 42.852 15.786 62.125 15.786 35.848 0 56.374-18.09 63.731-26.137 26.525-1.407 32.873-22.809 33.043-31.227a8.997 8.997 0 0 0-4.822-8.154zm-129.957-36.751a11.508 11.508 0 0 1-8.513 3.724 11.553 11.553 0 0 1-11.575-11.126c-.249-6.385 4.737-11.782 11.115-12.037a11.554 11.554 0 0 1 12.039 11.117 11.517 11.517 0 0 1-3.066 8.322z"
                            />
                          </g>
                        </svg>

                        <span className="font font-lato text-[12px]">
                          GreyHound
                        </span>
                      </button>
                    </Link>
                  )}
                  {(isSportAvailable("-100") || isSportAvailable("GAP")) && (
                    <Link
                      // to={userData?.is_demo ? "#" : "/livegames/aura/FAWK"}
                      to="#"
                    >
                      <button
                        className={`text-xs cursor-pointer uppercase border mr-1 active:border-primary hide-border-in-dark rounded-full text-nowrap whitespace-nowrap font-semibold bg-bg_Ternary8 hover:bg-bg_Ternary9  w-max px-3  py-1  text-text_HeaderDeskNavMenu   ${
                          location.pathname.includes("/livegames/aura/FAWK")
                            ? "border-primary text-active-new"
                            : ""
                        }`}
                        // onClick={() => {
                        //   if (userData?.is_demo) {
                        //     toastr.error("", "Please login from your read ID.");
                        //     return;
                        //   }
                        // }}
                        onClick={(e) => {
                          e.preventDefault();
                          if (auth) {
                            if (userData?.is_demo) {
                              toastr.error(
                                "",
                                "Please login from your read ID.",
                              );
                              return;
                            }
                            if (isSportAvailable("-100")) {
                              navigate("/livegames/aura/FAWK");
                            } else {
                              navigate("/casino-lobby/gapcasino/AURA");
                            }
                            if (
                              !location.pathname.includes("livegames/aura/FAWK")
                            ) {
                              actions.openSlotCasinoPopUp();
                            }
                          } else {
                            actions.setLoginNew(true);
                            actions.setLoginNavigationData({
                              page: "livegames/aura/FAWK",
                              ids: [],
                            });
                          }
                        }}
                      >
                        <span className="flex w-full items-center h-full gap-3">
                          <span className=" flex flex-row items-center justify-center">
                            <SVG_SpadeIcon width={15} height={15} fill="#000" />

                            <span className="font font-lato text-[12px] ml-[4px]">
                              Aura
                            </span>
                          </span>
                        </span>
                      </button>
                    </Link>
                  )}
                  {/* {isSportAvailable("GAP") && (
                    <Link to={"#"}>
                      <button
                        className={`text-xs cursor-pointer uppercase border mr-1 active:border-primary hide-border-in-dark rounded-full text-nowrap whitespace-nowrap font-semibold bg-bg_Ternary8 hover:bg-bg_Ternary9  w-max px-3  py-1  text-text_HeaderDeskNavMenu   ${
                          location.pathname.includes("/casino-lobby/gapcasino")
                            ? "border-primary text-active-new"
                            : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          if (auth) {
                            if (userData?.is_demo) {
                              toastr.error(
                                "",
                                "Please login from your read ID.",
                              );
                              return;
                            }
                            navigate("/casino-lobby/gapcasino");
                            if (
                              !location.pathname.includes(
                                "/casino-lobby/gapcasino",
                              )
                            ) {
                              actions.openSlotCasinoPopUp();
                            }
                          } else {
                            actions.setLoginNew(true);
                            actions.setLoginNavigationData({
                              page: "casino-lobby/gapcasino",
                              ids: [],
                            });
                          }
                        }}
                      >
                        <span className="flex w-full items-center h-full gap-3">
                          <span className=" flex flex-row items-center justify-center">
                            <SVG_CardDeckIcon
                              width={15}
                              height={15}
                              fill={"var(--color-secondary)"}
                            />

                            <span className="font font-lato text-[12px] ml-[4px]">
                              MAC88
                            </span>
                          </span>
                        </span>
                      </button>
                    </Link>
                  )} */}
                  {(isSportAvailable("QT") || isSportAvailable("GAP")) && (
                    <Link to={"#"}>
                      <button
                        className={`text-xs cursor-pointer uppercase border mr-1 active:border-primary hide-border-in-dark rounded-full text-nowrap whitespace-nowrap font-semibold bg-bg_Ternary8 hover:bg-bg_Ternary9  w-max px-3  py-1  text-text_HeaderDeskNavMenu   ${
                          location.pathname.includes("/casino-lobby/casino")
                            ? "border-primary text-active-new"
                            : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          if (auth) {
                            if (userData?.is_demo) {
                              toastr.error(
                                "",
                                "Please login from your read ID.",
                              );
                              return;
                            }
                            navigate("/casino-lobby/casino");
                            if (
                              !location.pathname.includes(
                                "/casino-lobby/casino",
                              )
                            ) {
                              actions.openSlotCasinoPopUp();
                            }
                          } else {
                            actions.setLoginNew(true);
                            actions.setLoginNavigationData({
                              page: "casino-lobby/casino",
                              ids: [],
                            });
                          }
                        }}
                      >
                        <span className="flex w-full items-center h-full gap-3">
                          <span className=" flex flex-row items-center justify-center">
                            <SVG_CardDeckIcon
                              width={15}
                              height={15}
                              fill={"var(--color-secondary)"}
                            />

                            <span className="font font-lato text-[12px] ml-[4px]">
                              Live Casino
                            </span>
                          </span>
                        </span>
                      </button>
                    </Link>
                  )}
                  {(isSportAvailable("QT") || isSportAvailable("GAP")) && (
                    <>
                      <Link to={"#"}>
                        <button
                          className={`text-xs cursor-pointer uppercase border mr-1 active:border-primary hide-border-in-dark rounded-full text-nowrap whitespace-nowrap font-semibold bg-bg_Ternary8 hover:bg-bg_Ternary9  w-max px-3  py-1  text-text_HeaderDeskNavMenu   ${
                            location.pathname.includes(
                              isSportAvailable("QT")
                                ? "casino-live/SPB-aviator/SPB"
                                : "gapcasino-live/151027/Virtual/MAC88",
                            )
                              ? "border-primary text-active-new"
                              : ""
                          }`}
                          onClick={(e) => {
                            e.preventDefault();
                            if (auth) {
                              if (userData?.is_demo) {
                                toastr.error(
                                  "",
                                  "Please login from your read ID.",
                                );
                                return;
                              }
                              navigate(
                                isSportAvailable("QT")
                                  ? "casino-live/SPB-aviator/SPB"
                                  : "gapcasino-live/151027/Virtual/MAC88",
                              );
                            } else {
                              actions.setLoginNew(true);
                              actions.setLoginNavigationData({
                                page: isSportAvailable("QT")
                                  ? "casino-live/SPB-aviator/SPB"
                                  : "gapcasino-live/151027/Virtual/MAC88",
                                ids: [],
                              });
                            }
                          }}
                        >
                          <span className="flex w-full items-center h-full gap-3">
                            <span className=" flex flex-row items-center justify-center">
                              <SVG_RocketIcon width={16} height={16} />
                              <span className="font font-lato text-[12px] ml-[4px]">
                                Aviator
                              </span>
                            </span>
                          </span>
                        </button>
                      </Link>
                      {/* <Link to={"#"}>
                        <button
                          className={`text-xs cursor-pointer uppercase border mr-1 active:border-primary hide-border-in-dark rounded-full text-nowrap whitespace-nowrap font-semibold bg-bg_Ternary8 hover:bg-bg_Ternary9  w-max px-3  py-1  text-text_HeaderDeskNavMenu   ${
                            location.pathname.includes("/casino-lobby/casino")
                              ? "border-primary text-active-new"
                              : ""
                          }`}
                          onClick={(e) => {
                            e.preventDefault();
                            if (auth) {
                              if (userData?.is_demo) {
                                toastr.error(
                                  "",
                                  "Please login from your read ID."
                                );
                                return;
                              }
                              navigate("/casino-lobby/casino");
                              if (
                                !location.pathname.includes(
                                  "/casino-lobby/casino"
                                )
                              ) {
                                actions.openSlotCasinoPopUp();
                              }
                            } else {
                              actions.setLoginNew(true);
                              actions.setLoginNavigationData({
                                page: "casino-lobby/casino",
                                ids: [],
                              });
                            }
                          }}
                        >
                          <span className="flex w-full items-center h-full gap-3">
                            <span className=" flex flex-row items-center justify-center">
                              <span className="md:hidden">
                                <SVG_CardDeckIcon width={16} height={16} />
                              </span>
                              <span className="font font-lato text-[12px] ml-[4px]">
                                Casino
                              </span>
                            </span>
                          </span>
                        </button>
                      </Link> */}
                      <Link to={"#"}>
                        <button
                          className={`text-xs cursor-pointer uppercase border mr-1 active:border-primary hide-border-in-dark rounded-full text-nowrap whitespace-nowrap font-semibold bg-bg_Ternary8 hover:bg-bg_Ternary9  w-max px-3  py-1  text-text_HeaderDeskNavMenu  ${
                            location.pathname === "/casino-lobby/slot-games"
                              ? "border-primary text-active-new"
                              : ""
                          } `}
                          onClick={(e) => {
                            e.preventDefault();
                            if (auth) {
                              if (userData?.is_demo) {
                                toastr.error(
                                  "",
                                  "Please login from your read ID.",
                                );
                                return;
                              }

                              navigate("/casino-lobby/slot-games");
                              if (
                                !location.pathname.includes(
                                  "/casino-lobby/slot-games",
                                )
                              ) {
                                actions.openSlotCasinoPopUp();
                              }
                            } else {
                              actions.setLoginNew(true);
                              actions.setLoginNavigationData({
                                page: "casino-lobby/slot-games",
                                ids: [],
                              });
                            }
                          }}
                        >
                          <span className="flex w-full items-center h-full gap-3">
                            <span className=" flex flex-row items-center justify-center">
                              <SVG_DiceIcon width={16} height={16} />
                              <span className="font font-lato text-[12px] ml-[4px]">
                                Slots
                              </span>
                            </span>
                          </span>
                        </button>
                      </Link>
                      <Link to={"#"}>
                        <button
                          className={`text-xs cursor-pointer uppercase border mr-1 active:border-primary hide-border-in-dark rounded-full text-nowrap whitespace-nowrap font-semibold bg-bg_Ternary8 hover:bg-bg_Ternary9  w-max px-3  py-1  text-text_HeaderDeskNavMenu  ${
                            location.pathname ===
                            "/casino-lobby/slot-games/Rubyplay"
                              ? "border-primary text-active-new"
                              : ""
                          } `}
                          onClick={(e) => {
                            e.preventDefault();
                            if (auth) {
                              if (userData?.is_demo) {
                                toastr.error(
                                  "",
                                  "Please login from your read ID.",
                                );
                                return;
                              }
                              navigate("/casino-lobby/slot-games/Rubyplay");
                            } else {
                              actions.setLoginNew(true);
                              actions.setLoginNavigationData({
                                page: "casino-lobby/slot-games/Rubyplay",
                                ids: [],
                              });
                            }
                          }}
                        >
                          <span className="flex w-full items-center h-full gap-3">
                            <span className=" flex flex-row items-center justify-center">
                              <SVG_RocketIcon width={16} height={16} />
                              <span className="font font-lato text-[12px] ml-[4px]">
                                Rubyplay-games
                              </span>
                            </span>
                          </span>
                        </button>
                      </Link>
                      <Link to={"#"}>
                        <button
                          className={`text-xs cursor-pointer uppercase border mr-1 active:border-primary hide-border-in-dark rounded-full text-nowrap whitespace-nowrap font-semibold bg-bg_Ternary8 hover:bg-bg_Ternary9  w-max px-3  py-1  text-text_HeaderDeskNavMenu  ${
                            location.pathname ===
                            "/casino-lobby/slot-games/Turbo%20Games"
                              ? "border-primary text-active-new"
                              : ""
                          }  `}
                          onClick={(e) => {
                            e.preventDefault();
                            if (auth) {
                              if (userData?.is_demo) {
                                toastr.error(
                                  "",
                                  "Please login from your read ID.",
                                );
                                return;
                              }
                              navigate("/casino-lobby/slot-games/Turbo Games");
                            } else {
                              actions.setLoginNew(true);
                              actions.setLoginNavigationData({
                                page: "casino-lobby/slot-games/Turbo Games",
                                ids: [],
                              });
                            }
                          }}
                        >
                          <span className="flex w-full items-center h-full gap-3">
                            <span className=" flex flex-row items-center justify-center">
                              <SVG_FishIcon />
                              <span className="font font-lato text-[12px] ml-[4px]">
                                Turbo-games
                              </span>
                            </span>
                          </span>
                        </button>
                      </Link>
                    </>
                  )}
                </div>

                {/* <div
                  className={`absolute right-0 bottom-0 shadow-lg  h-[37px] ${theme === "dark" ? "bg-black" : "bg-white"}   flex items-center justify-center px-1`}
                  onClick={() => {
                    setTheme(theme === "dark" ? "light" : "dark");
                  }}
                >
                  <img
                    onClick={() => {
                      setTheme(theme === "dark" ? "light" : "dark");
                    }}
                    src={
                      theme === "dark" ? "/light-theme.svg" : "/dark-theme.svg"
                    }
                    width={30}
                  />
                </div> */}
              </div>
            </div>

            {/* {!!pageInfo?.headerName && (
              <div className="lg:hidden flex flex-col  ">
                <div className="w-full h-[34px] pr-[4px] flex items-center justify-between gap-1  relative ">
                  <div className="app-bg flex-row w-full h-full flex cursor-pointer ">
                    <div className="w-[34px] h-full flex items-center justify-center   ">
                      <button
                        className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out w-8 rounded-sm h-6 flex ml-[4px] items-center justify-center bg-bg_Primary2 active:scale-150 cursor-pointer"
                        type="button"
                        onClick={() => {
                          navigate(-1);
                        }}
                      >
                        <SVG_BacktIcon width={20} height={20} />
                      </button>
                    </div>
                    <span className=" w-full h-full capitalize ml-[4px] flex items-center  text-text_Ternary  font-lato font-bold text-[16px] leading-5 ">
                      <span className="">
                        <span>{pageInfo?.headerName}</span>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            )} */}
          </div>

          {!!leftSideMenuOpen && (
            <LeftSideMenu
              setOpen={(val) => {
                setLeftSideMenuOpen(val);
              }}
            />
          )}

          {!!rightSideMenuOpen && (
            <RightSideMenu
              setOpen={(val) => {
                setRightSideMenuOpen(val);
              }}
            />
          )}
        </header>
      </div>
    </>
  );
};

export default connectToolbarDesktop()(ToolbarDesktop);
